import React from "react";
import PropTypes from "prop-types";
import {Text} from "@morningtrain/react-displays";
import useField from "../hooks/use-field";

function Display(props) {

    const {wrap} = useField(props);

    const Type = props.type;

    if (React.isValidElement(Type)) {
        return wrap(() => React.cloneElement(Type, {name: props.name}));
    }

    return wrap(() => (
        <Type name={props.name}/>
    ));
}

Display.defaultProps = {
    ...useField.defaultProps,
    type: Text,
};

Display.propTypes = {
    ...useField.propTypes,
    type: PropTypes.object.isRequired,
};

export default Display;
